import { Profile } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';
import axios, { AxiosError } from 'axios';

interface ProfileResponse {
  results: Profile[];
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
}
export const getProfiles = async ({
  page,
  pageSize,
  email = '',
}: {
  page: number;
  pageSize: number;
  email?: string;
}): Promise<ProfileResponse> => {
  const filter: { email?: string } = {};
  if (email) {
    filter['email'] = email;
  }
  try {
    const response = await axiosApiInstancePrivate.post<ProfileResponse>(
      `/v1/intranet/profiles`,
      {
        options: { page, limit: pageSize },
        filter,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getIntranetUsers = async ({
  page,
  pageSize,
  email = '',
}: {
  page: number;
  pageSize: number;
  email: string;
}): Promise<ProfileResponse> => {
  try {
    const filter: { email?: string } = {};
    if (email) {
      filter['email'] = email;
    }
    const response = await axiosApiInstancePrivate.post<ProfileResponse>(
      `/v1/intranet/users`,
      {
        options: { page, limit: pageSize },
        filter,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const putTassomutuoProfile = async (data: {
  intranetUserId: string;
  name: string;
  lastName: string;
  provinces: string[];
  createdBy: string;
  profileImage: File | string | null;
  htmlDescription: string;
  published: boolean;
}) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('lastName', data.lastName);
  formData.append('createdBy', data.createdBy);
  formData.append('htmlDescription', data.htmlDescription);
  formData.append('published', data.published.toString());

  data.provinces.forEach((province, index) => {
    formData.append(`provinces[${index}]`, province);
  });

  formData.append('profileImage', data.profileImage || '');

  try {
    const response = await axiosApiInstancePrivate.put(
      `/v1/intranet/profiles/${data.intranetUserId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const createIntranetUserWithTassoProfile = async (data: {
  email: string;
  name: string;
  lastName: string;
  provinces: string[];
  createdBy: string;
  profileImage: File | string | null;
  htmlDescription: string;
  published: boolean;
}) => {
  const formData = new FormData();
  formData.append('email', data.email);
  formData.append('name', data.name);
  formData.append('lastName', data.lastName);
  formData.append('createdBy', data.createdBy);
  formData.append('htmlDescription', data.htmlDescription);
  formData.append('published', data.published.toString());

  data.provinces.forEach((province, index) => {
    formData.append(`provinces[${index}]`, province);
  });

  formData.append('profileImage', data.profileImage || '');

  try {
    const response = await axiosApiInstancePrivate.post(
      `/v1/intranet/users/new`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const requestProfileUpdate = async () => {
  try {
    const response = await axiosApiInstancePrivate.post(
      `/v1/intranet/request-profile-update`
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
